const es = {
  NAV_HOME: 'Home',
  NAV_ABOUT: 'About',
  NAV_RESULT: 'Ver resultados',

  HOME_INTRO_1: '¿No os ponéis de acuerdo para elegir fin de semana para Primavera Sound 202X2!?',
  HOME_INTRO_2: 'Lo entendemos.',
  HOME_INTRO_3: 'Aquí os dejamos una ayudita.',
  HOME_INPUT_LABEL: 'Nombre de tu grupo de amigxs',
  HOME_BUTTON_LABEL: 'Empezar',

  ABOUT_INTRO: 'El cartel de Primavera Sound 2022 Barcelona - Sant Adrià no es solo el mejor de nuestra historia. También es el mayor, el más ecléctico, el más impactante, el más estelar. El más Primavera. El que necesita más tiempo para descubrir toda su singularidad. Una edición extraordinaria que se explica por la combinación entre los dos años sin festivales que hemos tenido que afrontar y el deseo de celebrar el 20º aniversario de Primavera Sound como se merece.',
  ABOUT_MORE_INFO: 'Más información en',
  ABOUT_MORE_INFO_URL: 'https://www.primaverasound.com/',

  VOTE_YOUR_NAME: 'Tu nombre',
  VOTE_CHOOSE_ONE: '¿A qué fin de semana quieres ir?',
  VOTE_BUTTON_LABEL: 'Votar',
  
  RESULT_VOTED: 'has votado',
  RESULT_CHOSE_SINGULAR: 'ha elegido este finde.',
  RESULT_CHOSE_PLURAL: 'han elegido este finde.',
  RESULT_SHARE_URL: 'Comparte esta URL para que voten tus amigxs.',
  RESULT_NOBODY: 'Nadie',

  ERROR_MIN_LENGHT_1: 'El nombre tiene que tener más de 1 caracter',
  ERROR_NO_OPTION: 'Hay que seleccionar una opción',

  OPTION_1: '1ST WEEKEND',
  OPTION_2: '2ND WEEKEND',
  OPTION_3: '1ST WEEKEND + 2ND WEEKEND',

  SHARE_MODAL_TITLE: 'Compartir en:',
  SHARE_EMAIL_TITLE: 'VOTE YOUR WEEKEND',
  SHARE_QUOTE: '¿No os ponéis de acuerdo para elegir fin de semana para Primavera Sound 202X2!? Lo entendemos. Aquí os dejamos una ayudita.',
}

export default es